import { createClient } from '@sanity/client'
import { SanityImage } from '@/app/types/blog'

export const sanityClient = createClient({
	projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
	dataset: process.env.NEXT_PUBLIC_SANITY_DATASET,
	useCdn: true,
	apiVersion: '2024-01-24',
})

/**
 * Builds a Sanity CDN image URL from a SanityImage reference
 * @param image - Sanity image object with asset reference
 * @param options - Optional width, height, and quality settings
 * @returns CDN URL string or empty string if image is invalid
 */
export function getSanityImageUrl(
	image: SanityImage | undefined | null,
	options: { width?: number; height?: number; quality?: number } = {}
): string {
	if (!image?.asset?._ref) return ''

	const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID
	const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET

	// Parse the asset reference: image-{id}-{width}x{height}-{format}
	const ref = image.asset._ref
	const [, id, dimensions, format] = ref.split('-')

	if (!id || !dimensions || !format) return ''

	const baseUrl = `https://cdn.sanity.io/images/${projectId}/${dataset}/${id}-${dimensions}.${format}`

	const params = new URLSearchParams()
	if (options.width) params.set('w', options.width.toString())
	if (options.height) params.set('h', options.height.toString())
	if (options.quality) params.set('q', options.quality.toString())
	params.set('auto', 'format') // Auto-convert to WebP when supported

	const queryString = params.toString()
	return queryString ? `${baseUrl}?${queryString}` : baseUrl
}
